import { createAction } from '@reduxjs/toolkit'

export const showEmailVerificationDialog = createAction('ui/showEmailVerificationDialog')
export const hideEmailVerificationDialog = createAction('ui/hideEmailVerificationDialog')
